import { render, staticRenderFns } from "./AcceptOrReject.vue?vue&type=template&id=cfeac2c2&scoped=true&"
import script from "./AcceptOrReject.vue?vue&type=script&lang=js&"
export * from "./AcceptOrReject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cfeac2c2",
  null
  
)

export default component.exports